import { __exports as a } from "../../../_virtual/expiration-month.js";
Object.defineProperty(a, "__esModule", { value: !0 });
a.expirationMonth = void 0;
function r(e, i, t) {
  return {
    isValid: e,
    isPotentiallyValid: i,
    isValidForThisYear: t || !1
  };
}
function o(e) {
  var i = (/* @__PURE__ */ new Date()).getMonth() + 1;
  if (typeof e != "string")
    return r(!1, !1);
  if (e.replace(/\s/g, "") === "" || e === "0")
    return r(!1, !0);
  if (!/^\d*$/.test(e))
    return r(!1, !1);
  var t = parseInt(e, 10);
  if (isNaN(Number(e)))
    return r(!1, !1);
  var n = t > 0 && t < 13;
  return r(n, n, n && t >= i);
}
a.expirationMonth = o;
export {
  a as default
};
